<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import DatePicker from '../../Shared/DatePicker.vue'

const props = defineProps<{
  disable?: boolean
}>()

const { umsokn } = useUmsokn()

const rules = {
  umsokn: {
    virkService: { required },
    virkFrom: {
      required: (val: any, parent: any) => !parent.virkService || !!val
    },
    virkTo: {
      required: (val: any, parent: any) => !parent.virkService || !!val
    }
  }
}

const v$ = useVuelidate(rules, { umsokn })

function todayISO() {
  return new Date().toISOString().split('T')[0]
}

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <h2 class="form__header">{{ $t('ororku_umsokn_step8_header') }}</h2>

      <v-row>
        <v-col cols="12">
          <p>{{ $t('ororku_umsokn_step8_virkService') }}</p>
          <v-radio-group
            v-model="umsokn.virkService"
            :readonly="props.disable"
            inline
            hide-details
            :error="v$.umsokn.virkService.$error"
            :error-messages="v$.umsokn.virkService.$error ? [$t('ororku_umsokn_step8_virkService_error')] : []"
          >
            <v-radio :label="$t('ororku_umsokn_step8_virkService_yes')" :value="true" />
            <v-radio :label="$t('ororku_umsokn_step8_virkService_no')" :value="false" />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row v-if="umsokn.virkService">
        <v-col cols="12" md="4">
          <DatePicker
            v-model="umsokn.virkFrom"
            :label="$t('ororku_umsokn_step8_virkFrom')"
            :disabled="props.disable"
            :max="todayISO()"
            :error="v$.umsokn.virkFrom.$error"
            :error-messages="v$.umsokn.virkFrom.$error ? [$t('ororku_umsokn_step8_virkFrom_error')] : []"
          />
        </v-col>
        <v-col cols="12" md="4">
          <DatePicker
            v-model="umsokn.virkTo"
            :label="$t('ororku_umsokn_step8_virkTo')"
            :disabled="props.disable"
            :max="todayISO()"
            :error="v$.umsokn.virkTo.$error"
            :error-messages="v$.umsokn.virkTo.$error ? [$t('ororku_umsokn_step8_virkTo_error')] : []"
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
